// Author: Claude Code | Event: Portrait System Implementation | Version: v3.2.38 | Modified: 2025-10-04
// Preload 7 slime portraits for agent display, mapping color index to portrait images

import { useState, useEffect } from 'react';

type PortraitMap = { [colorIndex: number]: string };

const PORTRAIT_FILES = [
  '/assets/portraits/像素史莱姆-0-idle_00.png', // 0: green
  '/assets/portraits/像素史莱姆-1-idle_00.png', // 1: red
  '/assets/portraits/像素史莱姆-2-idle_00.png', // 2: purple
  '/assets/portraits/像素史莱姆-3-idle_00.png', // 3: blue
  '/assets/portraits/像素史莱姆-4-idle_00.png', // 4: white
  '/assets/portraits/像素史莱姆-5-idle_00.png', // 5: black
  '/assets/portraits/像素史莱姆-6-idle_00.png', // 6: orange
];

export function usePortraitPreloader(): { portraits: PortraitMap; loading: boolean; error: string | null } {
  const [portraits, setPortraits] = useState<PortraitMap>({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let mounted = true;
    const loadedPortraits: PortraitMap = {};
    let loadedCount = 0;

    PORTRAIT_FILES.forEach((path, index) => {
      const img = new Image();
      img.onload = () => {
        if (!mounted) return;
        loadedPortraits[index] = path;
        loadedCount++;
        if (loadedCount === PORTRAIT_FILES.length) {
          setPortraits(loadedPortraits);
          setLoading(false);
        }
      };
      img.onerror = () => {
        if (!mounted) return;
        console.error(`[Portrait] Failed to load portrait ${index}: ${path}`);
        setError(`Failed to load portrait ${index}`);
        setLoading(false);
      };
      img.src = path;
    });

    return () => { mounted = false; };
  }, []);

  return { portraits, loading, error };
}
